module.exports = __webpack_public_path__ + "static/img/omnibees.358b62eb.png";